import { Text } from '@sitecore-jss/sitecore-jss-react';
import React from 'react';

const RadioQuestionItem = ({ fields, onChange, value, id, required, error }) => {
  const errorClass = error ? ' vds-form__radios--error' : '';

  return (
    <span className={`vds-form__radio-option${errorClass}`}>
      <input
        className="vds-form__radio"
        type="radio"
        id={`${id}_${fields.value?.value}`}
        name={id}
        value={fields.value?.value}
        checked={value === fields.value?.value}
        onChange={onChange}
        required={required}
        data-testid={fields.testid?.value}
      />
      <label
        className="vds-form__label vds-form__label--radio"
        htmlFor={`${id}_${fields.value?.value}`}
      >
        <Text field={fields.text} />
      </label>
    </span>
  );
};

export default RadioQuestionItem;
